import { AutoComplete, Input } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";

const AutoCompleteSearch = ({
  placeholder,
  functionSearch,
  filters,
  setFilters,
  entity,
  style,
  callback = null,
}) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);
  useEffect(() => {
    if (debouncedValue) {
      functionSearch(debouncedValue, (res) => {
        setOptions(
          res.map((item) => {
            return {
              ...item,
              value: item.name ? item.name : item.value,
              name: item.name ? item.name : item.value,
            };
          })
        );
      });
    }
  }, [debouncedValue]);
  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    setFilters({
      ...filters,
      [`${entity}`]: `${option.name}`,
    });
    if (callback) {
      callback();
    }
  };
  const handleInputEnter = () => {
    setFilters({ ...filters, [`${entity}`]: query });
    if (callback) {
      callback();
    }
  };
  return (
    <AutoComplete
      options={options}
      placeholder={placeholder}
      onChange={handleInputChange}
      onSelect={handleInputConfirm}
      style={{ width: "100%" }}
    >
      <Input
        style={style ? style : { height: "40px" }}
        onPressEnter={handleInputEnter}
      />
    </AutoComplete>
  );
};

export default AutoCompleteSearch;
